var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGrayDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24074 6.1142L0.414964 1.65079C-0.141042 1.00212 0.319867 0 1.17422 0H8.82578C9.68013 0 10.141 1.00212 9.58504 1.65079L5.75926 6.1142C5.36016 6.57981 4.63984 6.57981 4.24074 6.1142Z",
    fill: "#AFB7CA",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGrayDown);
export default __webpack_public_path__ + "static/media/arrow-gray-down.afb43915e6d53072272e80c7ed8d34ba.svg";
export { ForwardRef as ReactComponent };